import { ActivityView } from './../../../../../views/master-views/app.view/app.view.component';
import {
  EmailActivityLogEmailVM,
  EmailActivity
} from './../../../../../models/activities/email-activity';
import { Component, Inject, OnInit, forwardRef } from '@angular/core';
import { SecurityService, WorkflowService } from 'src/app/services';
import { ToastrService } from 'ngx-toastr';
import { Actions } from 'src/app/models';
import { Observable } from 'rxjs';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
  selector: 'wm-email-activity-view',
  templateUrl: './email-activity-view.component.html',
  styleUrls: ['./email-activity-view.component.css'],
  standalone: false
})
export class EmailActivityViewComponent extends ActivityView implements OnInit {
  activity: EmailActivity;
  applicationEmails: EmailActivityLogEmailVM[] = [];
  resendingEmail = false;
  // Added by amisha on 24/12/2025
  templateForPermitForm = false;

  confirmationModalData = {
    open: false,
    modalDescp: '',
    modalSubDescp: '',
    okBtn: true,
    closeBtn: false,
    yesNoBtn: false,
    status: 'default'
  };

  // End added by amisha on 24/12/2025

  constructor(
    @Inject(forwardRef(() => SecurityService))
    private _securitySvc: SecurityService,
    @Inject(forwardRef(() => WorkflowService))
    private _workflowSvc: WorkflowService,
    private _toastr: ToastrService,
    public layoutService: LayoutService
  ) {
    super();

    // Added by amisha on 24/12/2025
    // const useNewLayout= history.state?.useNewLayout;
    // this.templateForPermitForm = useNewLayout;
    // End added by amisha on 24/12/2025

    // Added by Deepak on 22/04/2026 to subscribe to layout changes
      layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
    // End Added by Deepak on 22/04/2026 to subscribe to layout changes
  }
  viewTitle(): string {
    return (
      (this.activity &&
        this.activity.model &&
        this.activity.model.screenName) ||
      'Email'
    );
  }

  ngOnInit() {
    if (
      this.activity.applicationEmails &&
      this.activity.applicationEmails.length > 0
    ) {
      this.applicationEmails = this.activity.applicationEmails;
    }
  }

  canResendEmails(): Observable<boolean> {
    return this._securitySvc.isLoginEntitled(Actions.RESEND_EMAILS);
  }
  // Changed by amisha on 24/12/2025
  resendEmailClick = () => {
    this.resendEmail();
  };
  //Updated by amisha on 24/12/2025 to handle modal pop up
  resendEmail() {
    this.resendingEmail = true;

    this._workflowSvc
      .reSendEmail(this.context.applicationId, this.activity.activityDataId)
      .subscribe(result => {
        this.resendingEmail = false;

        if (result) {

          if (!this.templateForPermitForm) {
            this._toastr.success(null, 'Email successfully re-sent', {
              timeOut: 3000,
              extendedTimeOut: 1000,
            });


            this.refreshView.emit();
            return;
          }

          this.confirmationModalData = {
            open: true,
            modalDescp: 'Email Sent Successfully',
            modalSubDescp: 'The email has been re-sent successfully.',
            okBtn: true,
            closeBtn: false,
            yesNoBtn: false,
            status: 'success'
          };
        }

        else {

          if (!this.templateForPermitForm) {
            this._toastr.error(
              'Please contact support if this persists.',
              'Failed to re-send email.',
              {
                timeOut: 4000,
                extendedTimeOut: 1000,
              }
            );

            return;
          }

          this.confirmationModalData = {
            open: true,
            modalDescp: 'Failed to Re-send Email',
            modalSubDescp: 'Please contact support if this persists.',
            okBtn: true,
            closeBtn: false,
            yesNoBtn: false,
            status: 'error'
          };
        }
      });
  }

  handleModalOk() {
    this.confirmationModalData.open = false;
    this.refreshView.emit();
  }

  handleModalClose() {
    this.confirmationModalData.open = false;
  }
}

